import { ActionReducerMapBuilder } from '@reduxjs/toolkit/react'
import { generateId } from '@repo/shared/uuid/uuid'

import { adminStoreActions, storeActions } from '@/store/actions'
import {
  assignCaseWorkerToBeneficiary,
  unassignCaseWorkerFromBeneficiary,
} from '@/store/case-workers/thunks'
import { NotificationState } from '@/store/notifications/notification'

export function caseWorkerCases(builder: ActionReducerMapBuilder<NotificationState>) {
  builder
    .addCase(
      storeActions.caseWorker.updateCurrent.fulfilled,
      (state, { payload: { caseWorker } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: { value: caseWorker.email },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      adminStoreActions.caseWorker.invite.fulfilled,
      (state, { payload: { caseWorker } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xCreated', // FIXME: change message
          descriptionTransOptions: { value: caseWorker.email },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      adminStoreActions.caseWorker.disableOrEnable.fulfilled,
      (
        state,
        {
          meta: {
            arg: { disabled },
          },
          payload: { caseWorker },
        },
      ) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: disabled ? 'xDisabled' : 'xEnabled',
          descriptionTransOptions: { value: caseWorker.email },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      adminStoreActions.caseWorker.update.fulfilled,
      (state, { payload: { caseWorker } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: { value: caseWorker.email },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(assignCaseWorkerToBeneficiary.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'xSuccess',
        icon: 'check',
        id: generateId(),
      })
    })
    .addCase(unassignCaseWorkerFromBeneficiary.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'xSuccess',
        icon: 'check',
        id: generateId(),
      })
    })
}
